import { render } from "./WomensHealthSelection.vue?vue&type=template&id=ddd2601a"
import script from "./WomensHealthSelection.vue?vue&type=script&lang=js"
export * from "./WomensHealthSelection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/testSelection/WomensHealthSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddd2601a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddd2601a', __exports__)) {
    console.log('reload')
    api.reload('ddd2601a', __exports__)
  }
  
  module.hot.accept("./WomensHealthSelection.vue?vue&type=template&id=ddd2601a", () => {
    console.log('re-render')
    api.rerender('ddd2601a', render)
  })

}


export default __exports__